import React from 'react';
export function Footer() {
  return <footer className="border-t border-line bg-ink px-4 pb-32 pt-10 text-center" data-id="element-144" data-mp="32wmqrybuniwl">
      <p className="font-display text-2xl font-extrabold uppercase text-white" data-id="element-145" data-mp="3gg0yw2enzvx4">OBD2 Diagnostic Blueprint™</p>
      <p className="mt-1 text-sm text-mist" data-id="element-146" data-mp="32pfgsfx1bq0a">Created by Jason Mitchell · Automotive Electronics Specialist</p>
      <p className="mx-auto mt-4 max-w-2xl text-sm leading-relaxed text-mist" data-id="element-147" data-mp="36ppihgdsnu9c">
        A practical educational system for understanding OBD2 fault codes, organizing diagnostic evidence, and
        planning automotive troubleshooting investigations.
      </p>
      <p className="mx-auto mt-4 max-w-2xl text-xs leading-relaxed text-mist/70" data-id="element-148" data-mp="3lf56iolxxllc">
        The Blueprint helps you organize diagnostic investigations. A fault code alone does not identify a defective
        component, and actual diagnostic procedures depend on the vehicle, available equipment, and manufacturer
        specifications. Always follow applicable manufacturer procedures, safety requirements, and diagnostic
        specifications.
      </p>
      <p className="mt-6 text-xs text-mist/70" data-id="element-149" data-mp="3lbdd6ucasbmc">© 2026 OBD2 Diagnostic Blueprint™. All rights reserved.</p>
    </footer>;
}